import {createTable, TableHeaderSpec} from "../../../../../components/table/CreateTable.tsx";
import React from "react";
import {Business} from "./BusinessesOverviewPage.tsx";
import {SecondaryButton} from "../../../../../components/general/SecondaryButton.tsx";
import {getLabelForLegalEntityType} from "../../../../../types/enums.ts";

interface Props {
    data: Array<Business>,
    onOpenClick: (business: Business) => void
}

export function BusinessTable({data, onOpenClick}: Props) {
    const businessNamesById = new Map(data.map((business) => [business.id, business.name]))

    const tableSpec: TableHeaderSpec<Business> = {

        columns: [

            {
                name: 'Name',
                field: 'name',
            },
            {
                name: 'Legal Entity Type',
                field: 'legal_entity_type',
                customRender: (row: Business) => getLabelForLegalEntityType(row.legal_entity_type),
            },
            {
                name: 'Registration Number',
                field: 'registration_number'
            },
            {
                name: 'FTEs',
                field: 'fte_amount',
            },
            {
                name: 'Industry',
                field: 'industry',
            },
            {
                name: 'Managing Business',
                field: 'managed_by',
                customRender: (row: Business) => (
                    <span>{row.managed_by ? businessNamesById.get(row.managed_by) ?? row.managed_by : '—'}</span>
                ),
            },
            {
                name: '',
                field: '',
                customRender: (row: Business) => (
                    <SecondaryButton onClick={() => onOpenClick(row)} title={'See details'}/>
                )
            },

        ]
    }

    const TableComponent = createTable<Business>(data, tableSpec)

    return (
        <>
            {TableComponent()}
        </>
    )
}
